import ErrorBar from './ErrorBar';
import { ErrorBarProps, ErrorBarValueProps } from './types';

export type { ErrorBarProps, ErrorBarValueProps };
export default ErrorBar;
